import { FunctionComponent, ReactNode } from "react";
import { AlertCircle, AlertTriangle, CheckCircle2, Info, LucideIcon } from "lucide-react";
import "./Alert.scss";

export type AlertVariant = "success" | "error" | "warning" | "info";

interface AlertProps {
    variant?: AlertVariant;
    children: ReactNode;
    /** Sobrescreve o icone padrao do variant */
    icon?: LucideIcon | null;
    className?: string;
}

const DEFAULT_ICONS: Record<AlertVariant, LucideIcon> = {
    success: CheckCircle2,
    error:   AlertCircle,
    warning: AlertTriangle,
    info:    Info,
};

const Alert: FunctionComponent<AlertProps> = ({
    variant = "info",
    children,
    icon,
    className = "",
}) => {
    const Icon = icon === null ? null : (icon ?? DEFAULT_ICONS[variant]);
    return (
        <div className={`ui-alert variant-${variant} ${className}`.trim()} role="alert">
            {Icon && <Icon size={16} className="ui-alert-icon" />}
            <span className="ui-alert-body">{children}</span>
        </div>
    );
};

export default Alert;
